
import { i18nText } from '@/locales';
import { Form } from "@/form/form";
import { Validate } from "@/plugins/Vuelidate/Decorators";
import { required } from "vuelidate/lib/validators";
import { Component } from "vue-property-decorator";
import { ServiceGeneralRequestType } from "@/form/serviceGeneral/serviceGeneral.types";
import { ISalons } from "@/entity/salons/salons.types";
import { IServicesCategory } from "@/entity/servicesCategory/services.category.types";
import { IServicesListItem } from "@/entity/services/services.types";

@Component
export default class ServiceGeneralForm extends Form {
    service_id = 0;
    @Validate(required, i18nText("Введите название услуги"))
    name = '';
    online_appointment_name = '';
    description = '';
    // @Validate(required, 'Введите стоимость для косметолога')
    price_first : number | null = null;
    // @Validate(required, 'Введите стоимость для ведущего косметолога')
    price_second : number | null = null;
    @Validate(required, i18nText("Введите длительность услуги"))
    service_duration = '';
    image = 1;
    @Validate(required, i18nText("Выберите название услуги"))
    category_id : number | null = null;
    categorys   : IServicesCategory | null = null;
    @Validate(required, i18nText("Выберите студию"))
    salon_id    : number | null = null;
    salons      : ISalons | null = null;
    @Validate(required, i18nText("Онлайн оплата"))
    online_payment_id : number | null = null;
    @Validate(required, i18nText("Выеберите косметологов"))
    cosmetologists_id = [];
    @Validate(required, i18nText("Является ли запись онлайн"))
    online_appointment : boolean = false;
    @Validate(required, i18nText("Является ли запись активной"))
    active : boolean  = false;
    key = 0;
    staff!: [];
    products!: [];

    getFormData() : ServiceGeneralRequestType {
        return {
            id:   this.service_id,
            key: this.category_id,
            name: this.name,
            description: this.description,
            online_appointment_name: this.online_appointment_name,
            price_first:  this.price_first,
            price_second:  this.price_second,
            service_duration: this.service_duration,
            category_id: this.category_id,
            salon_id: this.salon_id,
            image: this.image,
            cosmetologists_id: this.cosmetologists_id,
            active: this.active,
            online_appointment: this.online_appointment,
            staff: this.staff
        }
    }

    setFormData( service: IServicesListItem | null ) : void{
        if (service !== undefined && service != null)
        {
            //this.cosmetologists = workers;
            this.service_id   = service.id;
            this.name = service.name;
            this.description = service.description;
            this.online_appointment_name = service.online_appointment_name;
            this.price_first = service.price_first;
            this.price_second = service.price_second;
            this.service_duration = service.service_duration;
            this.category_id = service.category_id;
            this.salon_id = service.salon_id;
            this.image = service.image;
            this.active = service.active;
            this.online_appointment = service.online_appointment;
            this.key = service.category_id;
            this.staff = service.staff;
            this.products = service.products;
        }
    }
}
